import React, { useState, useEffect } from "react";
import "./App.css";
import phone from "./assets/phone.png";
import typing from "./assets/typing.png";

const features = [
  { icon: "⌨️", title: "Арван хуруугаар бичих", desc: "Гарын зөв байрлалд дасан, хурдан бичих ур чадвар эзэмшинэ" },
  { icon: "🏆", title: "Дасгал, тест", desc: "Монгол болон Англи хэл дээрх олон төрлийн дасгал, тест бэлтгэгдсэн" },
  { icon: "🆓", title: "Үнэгүй татах", desc: "Программыг татаж авах нь бүрэн үнэгүй. Суулгаад шууд эхлэх боломжтой." },
  { icon: "💻", title: "Windows 10 & 11", desc: "Орчин үеийн Windows платформ дээр бүрэн ажилладаг хөнгөн программ" },
  { icon: "🇲🇳", title: "Монгол хэлтэй", desc: "Монгол хэлний кирилл үсгийн дасгал бүхий цор ганц программ" },
];

const faqs = [
  { q: "Программ ямар үнэтэй вэ?", a: "Программыг татаж авах үнэгүй. Ашиглалтын нөхцөлийн талаар дэлгэрэнгүй мэдээлэл авахыг хүсвэл бидэнтэй холбогдоно уу." },
  { q: "Ямар үйлдлийн систем дэмждэг вэ?", a: "Windows 10 болон Windows 11 дээр бүрэн ажилладаг." },
  { q: "Суулгахад юу хэрэгтэй вэ?", a: "Fasttypemon.msi файлыг татаж аваад суулгавал хангалттай. Нэмэлт программ шаардахгүй." },
  { q: "Хэр хурдан бичиж сурч болох вэ?", a: "Өдөрт 15–20 минут тогтмол дасгалласнаар ихэнх хэрэглэгчид 1–2 сарын дотор мэдэгдэхүйц ахиц гаргадаг." },
  { q: "Монгол хэлний дасгал байдаг уу?", a: "Тийм. Монгол кирилл болон Англи хэл хоёуланд нь зориулсан дасгал, тест багтсан байдаг." },
];

const exercises = [
  {
    icon: "⌨️",
    title: "Гарын байрлалын дасгал",
    desc: "Арван хурууны зөв байрлал, эхлэгчдэд зориулсан үсэг бүрийн дасгал.",
  },
  {
    icon: "🇲🇳",
    title: "Монгол хэлний дасгал",
    desc: "Кирилл үсэг, үг, өгүүлбэр, уран зохиолын эшлэлээр бүтсэн олон төрлийн текст.",
  },
  {
    icon: "🔤",
    title: "Англи хэлний дасгал",
    desc: "Үсэг, үг, өгүүлбэрийн дасгалаас эхлээд хурдны тест хүртэл.",
  },
  {
    icon: "📝",
    title: "IELTS Writing Task 1 — Academic",
    desc: "График, диаграмм, хүснэгт, процессийн тайлбар бичих сэдэвт бэлтгэгдсэн жишээ эссэг бичих дасгал.",
  },
  {
    icon: "✉️",
    title: "IELTS Writing Task 1 — General",
    desc: "Албан болон албан бус захидал (formal, semi-formal, informal letter) бичих дасгал.",
  },
  {
    icon: "📄",
    title: "IELTS Writing Task 2 — Academic & General",
    desc: "Opinion, discussion, problem-solution, advantages/disadvantages төрлийн эссэгийг бичих дасгал, жишээ хариулт.",
  },
  {
    icon: "⏱️",
    title: "Хурд, нарийвчлалын тест",
    desc: "WPM (Words Per Minute) болон алдааны хувийг хэмжих хугацаатай тест.",
  },
  {
    icon: "🏅",
    title: "Түвшин ахисан дасгал",
    desc: "Тоо, тэмдэгт, программчлалын кодын дасгал бичих дасгал.",
  },
];

const testimonials = [
  { name: "Б. Энхтуяа", role: "Оффисын ажилтан", text: "Ажил дээрээ маш их бичих шаардлагатай байсан. Fasttypemon ашигласнаар 2 сарын дотор бичих хурд маань хоёр дахин нэмэгдсэн!" },
  { name: "Д. Батбаяр", role: "Оюутан", text: "Энгийн, ашиглахад хялбар. Монгол хэлний дасгалтай байгаа нь маш их тус болсон." },
  { name: "Н. Сарнай", role: "Нярав", text: "Хурдан бичиж сурмаар байсан ч сургалт, ном олдохгүй байсан. Энэ программ надад хамгийн хялбараар сурахад тусалсан." },
];

function App() {
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href").slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.replaceState(null, "", "#" + id);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="site">
      <a
        href="https://m.me/753577438049822"
        target="_blank"
        rel="noopener noreferrer"
        className="messenger-fab"
        aria-label="Messenger дээр бичих"
      >
        <svg viewBox="0 0 36 36" width="28" height="28" aria-hidden="true">
          <path fill="#fff" d="M18 2C9.16 2 2 8.64 2 16.8c0 4.65 2.32 8.78 5.95 11.49V34l5.44-2.99c1.45.4 2.99.62 4.61.62 8.84 0 16-6.64 16-14.83C34 8.64 26.84 2 18 2zm1.59 19.95l-4.07-4.34-7.95 4.34 8.74-9.28 4.17 4.34 7.85-4.34-8.74 9.28z"/>
        </svg>
      </a>

      {/* NAV */}
      <nav className="nav">
        <div className="nav-logo">
          <span className="nav-box"></span>
          <span className="nav-brand">Fasttypemon</span>
        </div>
        <div className="nav-links">
          <a href="#features">Онцлог</a>
          <a href="#exercises">Дасгал</a>
          <a href="#faq">Асуулт</a>
          <a href="https://fasttypemon.mn/download/guide.pdf">Заавар</a>
          <a href="tel:+97699886117" className="nav-phone">
            <img src={phone} alt="утас" />
            99886117
          </a>
          <a href="https://fasttypemon.mn/download/fasttypemon.msi" className="nav-cta">Татах</a>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-text">
          <h1>Арван хуруугаар<br />хурдан бичиж сурах<br /><span>монгол программ</span></h1>
          <p className="hero-sub">Татах нь үнэгүй.<br />Windows 10 &amp; 11 дээр бүрэн ажилладаг.</p>
          <a href="https://fasttypemon.mn/download/fasttypemon.msi" className="btn-primary">
            Үнэгүй татах
          </a>
          <p className="hero-note">fasttypemon.mn · Windows 10, 11</p>
        </div>
        <div className="hero-img">
          <img src={typing} alt="арван хуруугаар бичих дасгал" />
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="features">
        <h2>Яагаад Fasttypemon?</h2>
        <div className="features-grid">
          {features.map((f) => (
            <div className="feature-card" key={f.title}>
              <span className="feature-icon">{f.icon}</span>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* EXERCISES */}
      <section className="exercises" id="exercises">
        <h2>Дасгалууд</h2>
        <p className="exercises-intro">
          Энгийн гарын байрлалаас эхлээд IELTS Writing Task 1, 2 (Academic, General) хүртэл — нэг программ дотор бүх төрлийн дасгал.
        </p>
        <div className="exercises-grid">
          {exercises.map((e) => (
            <div className="exercise-card" key={e.title}>
              <span className="exercise-icon">{e.icon}</span>
              <h3>{e.title}</h3>
              <p>{e.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials">
        <h2>Хэрэглэгчдийн сэтгэгдэл</h2>
        <div className="testimonials-grid">
          {testimonials.map((t) => (
            <div className="testimonial-card" key={t.name}>
              <p className="testimonial-text">"{t.text}"</p>
              <div className="testimonial-author">
                <strong>{t.name}</strong>
                <span>{t.role}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="faq" id="faq">
        <h2>Түгээмэл асуултууд</h2>
        <div className="faq-list">
          {faqs.map((item, i) => (
            <div className="faq-item" key={i}>
              <button className="faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                {item.q}
                <span>{openFaq === i ? "▲" : "▼"}</span>
              </button>
              {openFaq === i && <div className="faq-a">{item.a}</div>}
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2>Өнөөдөр эхлэх цаг болжээ</h2>
        <p>Татах нь үнэгүй. Арван хуруугаар хурдан бичиж сурч эхлэ.</p>
        <a href="https://fasttypemon.mn/download/fasttypemon.msi" className="btn-primary">
          Үнэгүй татах — fasttypemon.msi
        </a>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <p>© 2024 Fasttypemon · <a href="tel:+97699886117">99886117</a> · fasttypemon.mn</p>
        <p className="footer-sub">Программыг ашиглаж гарын зөв байрлалаар хурдан бичиж суран технологийн зуунд манлайлаарай.</p>
      </footer>
    </div>
  );
}

export default App;
